import React, {Component} from 'react';
import './App.less';

import * as monaco from 'monaco-editor';
import ActionCtrlD from './action/ActionCtrlD';
import settingImg from "./img/settings.svg"
import {readLocalStorage, saveToLocalStorage} from "./utils/Utils";

const languageKey = "language";
const contentKey = "content";
const wrapWordKey = "wrapWord";

let localLanguage = readLocalStorage(languageKey)
let localContent = readLocalStorage(contentKey)
let localWrapWord = readLocalStorage(wrapWordKey)

class App extends Component {

    constructor(args) {
        super(args);

        this.vsEditor = null

        this.languages = [
            "plainText",
            "java",
            "javascript",
            "html",
            "less",
            "sql"
        ]

        this.state = {
            show: true,
            language: localLanguage ? localLanguage : this.languages[0],
            wrapWord: localWrapWord ? localWrapWord : "on"
        }
    }

    componentWillUnmount() {
        console.log("componentWillUnmount 方法调用");
        window.removeEventListener("resize", this.vsEditorLayout.bind(this));
    }

    componentDidMount() {

        let that = this
        this.vsEditor = monaco.editor.create(document.getElementById('VsEditor'), {
            value: localContent ? localContent : "",
            language: this.state.language,
            wordWrap: this.state.wrapWord
        });

        //手动增加Ctrl+D的功能。
        this.vsEditor.addAction(ActionCtrlD);

        window.addEventListener("resize", this.vsEditorLayout.bind(this));
        window.onbeforeunload = function (event) {
            saveToLocalStorage(contentKey, that.vsEditor.getValue())
        }


    }

    render() {
        return (
            <div className={this.state.show ? 'App ShowPanel' : 'App'}>
                <div id="VsEditor"></div>
                <div className="ToolPanel">
                    <span className="ChooseLang">
                        选择语言：
                        <select value={this.state.language} onChange={this.changeLanguage.bind(this)}>
                        {this.languages.map(function (item, index) {
                            return (
                                <option key={index} value={item}>{item}</option>
                            )
                        })}
                    </select>
                    </span>
                    <span className="WrapWord">
                        换行：
                        <select value={this.state.wrapWord} onChange={this.changeWrapWord.bind(this)}>
                            <option value="on">自动换行</option>
                            <option value="off">不换行</option>
                        </select>
                    </span>
                </div>
                <img className="ToggleImage" alt="开关" src={settingImg} onClick={this.togglePanel.bind(this)}></img>
            </div>
        );
    }

    vsEditorLayout() {
        console.log("vsEditorLayout 方法调用");
        this.vsEditor.layout();
    }

    togglePanel() {

        this.setState({
            show: !this.state.show
        })

    }

    changeLanguage(e) {


        let language = e.target.value
        this.setState({
            show: !this.state.show,
            language: language
        })


        if (this.vsEditor) {
            monaco.editor.setModelLanguage(this.vsEditor.getModel(), language)
        }
        saveToLocalStorage(languageKey, language)
    }

    changeWrapWord(e) {


        let wrapInfo = e.target.value
        this.setState({
            show: !this.state.show,
            wrapWord: wrapInfo
        })

        if (this.vsEditor) {
            this.vsEditor.updateOptions({wordWrap: wrapInfo});
        }
        saveToLocalStorage(wrapWordKey, wrapInfo)
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js